import loanDialog from "./loanDialog/loanDialog.html";
import loanDialogCtrl from "./loanDialog/loanDialog.controller";

class Controller {
  constructor(
    $mdDialog,
    $stateParams,
    $injector,
    Loan,
    LoanTransforms,
    InvoiceTransforms,
    Events,
    ActionLists
  ) {
    "ngInject";

    this.Events = Events;
    this.Loan = Loan;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.sections = $injector.get("Sections").settingsSections;
    this.loanResourceId = this.$stateParams.id;
    this.LoanTransforms = LoanTransforms;
    this.InvoiceTransforms = InvoiceTransforms;
    this.invoiceItemParams = {
      loan: this.$stateParams.id,
      type: ["bonus_loan", "deduction_loan"],
      isCityRequired: false,
    };
    this.invoiceItemFields = this.LoanTransforms.invoiceItemFields;
    this.invoiceItemActions = ActionLists.all.invoiceItemActions;
  }

  $onInit() {
    this.Loan.get(this.$stateParams.id).$promise.then((response) => {
      this.loan = this.LoanTransforms.justify(response);
    });

    this.finalizeLoan = () => {
      this.$mdDialog.show({
        controller: loanDialogCtrl,
        controllerAs: "$ctrl",
        template: loanDialog,
        locals: {
          loan: this.loan,
        },
      });
    };
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/loan/loan.controller.js